import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("xv_admin_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});
